import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EditLiabilityData } from '../models/edit-liability-data.model';
import { AppConfig } from '../../core/services/app-config.service';

export class EditLiabilityForm extends FormGroup {
  constructor(title: string, amount: number, paymentDue: Date, appConfig: AppConfig,
              disabled: boolean = false, disabledAmount: boolean = false) {
    super({
      title: new FormControl({ value: title, disabled: disabled },
        [Validators.minLength(4), Validators.maxLength(40)]),
      amount: new FormControl({
        value: amount,
        disabled: disabled || disabledAmount,
      }, [Validators.required, Validators.min(0.01), Validators.max(appConfig.config.liabilityAmountLimit)]),
      paymentDue: new FormControl(paymentDue),
    });
  }

  get title(): FormControl {
    return this.get('title') as FormControl;
  }

  get amount(): FormControl {
    return this.get('amount') as FormControl;
  }

  get paymentDue(): FormControl {
    return this.get('paymentDue') as FormControl;
  }

  public getFinalData(): EditLiabilityData {
    return {
      title: this.title.value,
      amount: !!this.amount ? this.amount.value.toFixed(2) : 0,
      paymentDue: this.paymentDue.value,
    };
  }
}
